export default class PicPartNer {
  removeBackDrop() {
    setTimeout(() => {
      $('.modal-backdrop').remove()
    }, 500);
  }
}
